const LAST_SEEN_STORAGE_KEY = 'klayder-admin-inbox-last-seen'

type LastSeenMap = Record<string, string>

export const readLastSeenMap = (): LastSeenMap => {
  if (typeof window === 'undefined') return {}
  try {
    const raw = window.localStorage.getItem(LAST_SEEN_STORAGE_KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw) as LastSeenMap
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch {
    return {}
  }
}

const writeLastSeenMap = (map: LastSeenMap) => {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(LAST_SEEN_STORAGE_KEY, JSON.stringify(map))
}

export const markConversationSeen = (
  conversationId: number,
  seenAt: string | null | undefined
) => {
  if (!seenAt) return
  const map = readLastSeenMap()
  map[String(conversationId)] = seenAt
  writeLastSeenMap(map)
}

export const isConversationSeenUpTo = (
  conversationId: number,
  messageAt: string | null | undefined,
  lastSeenMap: LastSeenMap
): boolean => {
  if (!messageAt) return true
  const seenAt = lastSeenMap[String(conversationId)]
  if (!seenAt) return false
  return messageAt <= seenAt
}
